// extracted by mini-css-extract-plugin
module.exports = {"atrribute":"TokenDetail_atrribute__uoE2z","attributesContainer":"TokenDetail_attributesContainer__4X59R","attributesGroup":"TokenDetail_attributesGroup__3XLNI"};